import React, {ReactElement} from "react";

import {css, generateKeyId} from "/src/utils/utils";
import {MaybeType} from "/src/types";

import MarkdownText from "../../markdown/markdown-text/MarkdownText";
import ModuleBody from "../../layouts/module-body/ModuleBody";
import CTAButton, {CTA} from "../../buttons/cta-button/CTAButton";

import * as styles from "./text-hero.module.scss";

interface TextHeroProps {
  copy: MaybeType<string>;
  ctas: MaybeType<Array<CTA>>;
  eyebrow: MaybeType<string>;
  headline: MaybeType<string>;
  darkMode?: MaybeType<boolean>;
  titleWithLineBreaks: MaybeType<string>;
  useTitleWithLineBreaks: MaybeType<boolean>;
  fullbleed: MaybeType<boolean>;
}

const TextHero = (props: TextHeroProps): ReactElement => {
  const {
    copy,
    ctas,
    eyebrow,
    headline,
    darkMode,
    titleWithLineBreaks,
    useTitleWithLineBreaks,
    fullbleed,
  } = props;

  const isDarkMode = darkMode === true;
  const isFullBleed = fullbleed === true;

  return (
    <div
      className={css(
        styles.textHero,
        isDarkMode ? styles.textHeroDark : "",
        isFullBleed ? styles.textHeroFullbleed : ""
      )}
    >
      <ModuleBody classes={styles.textHero__body}>
        {eyebrow && (
          <p className={css("eyebrow", styles.textHero__eyebrow)}>{eyebrow}</p>
        )}

        {useTitleWithLineBreaks && titleWithLineBreaks != null && (
          <h1 className={css("h1", styles.textHero__headline)}>
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html:
                  titleWithLineBreaks != null
                    ? titleWithLineBreaks.replace(/(\n|\r)/g, "<br/>")
                    : "",
              }}
            />
          </h1>
        )}

        {!useTitleWithLineBreaks && headline != null && (
          <h1 className={css("h1", styles.textHero__headline)}>{headline}</h1>
        )}

        {copy && <MarkdownText text={copy} classes={styles.textHero__copy} />}

        {/* assume that ctas should be secondary */}
        {ctas && (
          <ul className={styles.textHero__ctas}>
            {ctas.map((cta, i) => {
              return (
                <li
                  key={generateKeyId(`${cta.label.toLowerCase()}-${i}`)}
                  className={styles.textHero__cta}
                >
                  <CTAButton darkMode cta={cta} kind={"secondary"} />
                </li>
              );
            })}
          </ul>
        )}
      </ModuleBody>
    </div>
  );
};

export default TextHero;
